import { render, staticRenderFns } from "./AiChatMessage.vue?vue&type=template&id=0d940a49&scoped=true"
import script from "./AiChatMessage.vue?vue&type=script&lang=js"
export * from "./AiChatMessage.vue?vue&type=script&lang=js"
import style0 from "./AiChatMessage.vue?vue&type=style&index=0&id=0d940a49&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d940a49",
  null
  
)

export default component.exports